<template>
	<div>
		<div class="demo-upload-list" v-for="(item,index) in uploadList" :key="index">
			<template v-if="item.status === 'finished'">
				<img :src="item.url">
				<div class="demo-upload-list-cover">
					<Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
					<Icon type="ios-trash-outline" v-if="!onlyRead" @click.native="handleRemove(item)"></Icon>
				</div>
			</template>
			<template v-else>
				<Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
			</template>
		</div>
		<Upload v-if="!onlyRead" ref="upload" :show-upload-list="false" :on-success="handleSuccess"
			:on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload"
			multiple type="drag" :action="actionUrl" style="display: inline-block;width:100px;">
			<div style="width:100px;height:100px;line-height: 100px;">
				<div style="font-size: 30px;">+</div>
			</div>
		</Upload>
		<Modal title="阅览图片" v-model="visible" width="650px">
			<img :src="imgName" v-if="visible" style="width: 100%">
		</Modal>
	</div>
</template>
<script>
	import config from "../../config";

	export default {
		props: ['onlyRead', 'edit'],
		data() {
			return {
				actionUrl: '',
				imgName: '',
				visible: false,
				uploadList: []
			}
		},
		created() {
			this.actionUrl = 'https://zycloud.gzjzg8.com/app/api/uploadFile';
		},
		methods: {
			handleView(url) {
				this.imgName = url;
				this.visible = true;
			},
			handleRemove(file) {
				const fileList = this.$refs.upload.fileList;
				this.uploadList.splice(fileList.indexOf(file), 1);
			},
			handleSuccess(res, file) {
				if(this.uploadList == undefined || this.uploadList == ""){
					this.uploadList = []
				}
				console.log(this.uploadList)
				file.url = res.data.url
				console.log(file)
				this.uploadList.push(file)
				console.log(this.uploadList)
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: 'The file format is incorrect',
					desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: 'Exceeding file size limit',
					desc: 'File  ' + file.name + ' is too large, no more than 2M.'
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 20;
				if (!check) {
					this.$Notice.warning({
						title: '最多只能上传20张图片.'
					});
				}
				return check;
			}
		},
		mounted() {
			if (!this.onlyRead) {
				this.uploadList = this.$refs.upload.fileList;
			}
		}
	}
</script>
<style scoped lang="less">
	.demo-upload-list {
		display: inline-block;
		width: 100px;
		height: 100px;
		text-align: center;
		line-height: 100px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
